"use client";

import { Search, Bell } from "lucide-react";
import { ReactNode } from "react";

export function Topbar({ children }: { children?: ReactNode }) {
  return (
    <div className="flex items-center justify-between px-8 py-3.5 bg-white border-b border-[#E5E7EB] sticky top-0 z-10">
      <div className="flex-1 max-w-[480px]">
        <div className="flex items-center gap-2.5 px-3.5 py-2 bg-white border-[1.5px] border-[#E5E7EB] rounded-[10px] text-[#6B7280] focus-within:border-[#CD0985]">
          <Search size={14} strokeWidth={2} />
          <input
            className="flex-1 bg-transparent border-0 outline-none text-[13px] text-[#111] font-sans placeholder:text-[#9CA3AF]"
            placeholder="Buscar por cédula, nombre, teléfono..."
          />
          <span className="font-display text-[10.5px] px-1.5 py-0.5 bg-[#F3F4F6] border border-[#E5E7EB] rounded text-[#6B7280] font-semibold">
            ⌘K
          </span>
        </div>
      </div>
      <div className="flex items-center gap-3">
        <button className="relative w-9 h-9 border border-[#E5E7EB] bg-white rounded-[10px] flex items-center justify-center text-[#6B7280] hover:text-[#111]">
          <Bell size={16} strokeWidth={1.8} />
        </button>
        {children}
      </div>
    </div>
  );
}
